import { Container, Grid } from "@mui/material";
import HTMLReactParser from "html-react-parser";
import { useGlobal } from "../../utils/GlobalContext";
import { useNavigate } from "react-router-dom";

function PrivacyTerms() {
  const { state, dispatch } = useGlobal();
  const navigate = useNavigate();
  if (state.UserProfile.IsExistingUser === false) {
    navigate("/account");
}
  return (
    <>
      <div className="container">
      <Container maxWidth="xl">
        <Grid container spacing={4}>
          <Grid item xs={12} md={12}>
            <div>
                <div>
                  {HTMLReactParser(state.Conference.Privacy)}
                </div>
            </div>
          </Grid>
        </Grid>
      </Container>
      </div>
    </>
    
  );
}
  
export default PrivacyTerms;